import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = [ "ccNumber", "postalCode", "countryCode", "nameOnCard", "email", "cvv",
                     "expirationMonth", "expirationYear", "creditCardId", "lastFour" ]

  handleSubmit(event) {
    event.preventDefault()
    // event.currentTarget.disabled = true
    this.createCreditCard()
    return false
  }

  // private -------------------->

  createCreditCard() {
    WePay.set_endpoint(this.endpoint)
    // const response = WePay.credit_card.create(this.cardParams, data => this.callback(data))
    const response = WePay.credit_card.create(this.cardParams, this.callback.bind(this))
    if (response.error) {
      this.failure(response)
    }
  }

  callback(data) {
    if (data.error) {
      this.failure(data)
    }
    else {
      this.success(data.credit_card_id)
    }
  }

  success(credit_card_id) {
    // Store credit card id
    this.creditCardIdTarget.value = credit_card_id
    // Store last four
    this.lastFourTarget.value = this.ccNumberTarget.value.substr(-4)
    // Blank number out
    this.ccNumberTarget.value = ""
    this.ccNumberTarget.removeAttribute("name")
    // Submit form
    this.form.submit()
  }

  failure(response) {
    document.getElementById('credit_card_form_wrapper').classList.add('show-errors')
    if (typeof(DT.alert) != "undefined"){
      DT.alert({ message: 'There was a problem. Please check your information below and try again.' })
    }
    this.form.querySelector('input[type=submit]').value = 'Try again'
    $(this.form).trigger('ajax:complete')
    $("html, body").animate({ scrollTop: 0 }, 500)
  }

  get form() {
    return this.element
  }

  get endpoint() {
    return this.data.get('endpoint')
  }

  get clientId() {
    return this.data.get('clientId')
  }

  get cardParams() {
    return {
      client_id:        this.clientId,
      address: {
        postal_code:    this.postalCodeTarget.value,
        country:        this.countryCodeTarget.value
       },
      user_name:        this.nameOnCardTarget.value,
      email:            this.emailTarget.value,
      cc_number:        this.ccNumberTarget.value,
      cvv:              this.cvvTarget.value,
      expiration_month: this.expirationMonthTarget.value,
      expiration_year:  this.expirationYearTarget.value,
    }
  }
}
